'use client'

import { format } from 'date-fns'
import { Calendar, ChevronLeft } from 'react-feather'
import { useTranslations } from '@/lib/next-shim'
import { StatusBadge } from '@/components/ui/StatusBadge'
import { Expertise } from '../lib/expertise-detail.types'

type DetailHeaderProps = {
  speciality: string
  status: Expertise['status']
  statusText: string
  startDate: Expertise['startDate']
  onClose: () => void
}

export function DetailHeader({ speciality, status, statusText, startDate, onClose }: DetailHeaderProps) {
  const t = useTranslations()

  return (
    <>
      <button
        type="button"
        onClick={onClose}
        className="inline-flex w-fit items-center gap-1 rounded-md text-sm font-medium text-gray-600 transition-colors hover:text-primary focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary"
      >
        <ChevronLeft size={18} aria-hidden="true" />
        {t('common.goBack')}
      </button>

      <header className="flex flex-col gap-2 border-b border-gray-200 pb-4">
        <div className="flex flex-wrap items-center gap-3">
          <h1 className="text-xl font-bold capitalize text-gray-900 md:text-2xl">{speciality}</h1>
          <StatusBadge status={status} statusText={statusText} />
        </div>
        <p className="flex items-center gap-1.5 text-sm text-gray-500">
          <Calendar size={15} aria-hidden="true" />
          {format(new Date(startDate), 'PPP')}
        </p>
      </header>
    </>
  )
}
